import { LoadingSpinner } from '@/components/LoadingSpinner';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { useTranslation } from 'react-i18next';

const HrisIntegrationContainer = lazy(() =>
  import('@features/hris-integration/components/HrisIntegrationContainer').then((module) => ({
    default: module.HrisIntegrationContainer,
  }))
);

export const Route = createFileRoute('/_auth/integration')({ component: IntegrationComponent });

function IntegrationComponent() {
  const { t } = useTranslation();
  return (
    <Suspense fallback={<LoadingSpinner message={t('common.splash.loading')} />}>
      <HrisIntegrationContainer />
    </Suspense>
  );
}
